<template>
    <div>
        <preloader-component></preloader-component>
        <router-view></router-view>
    </div>
</template>

<script>
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
export default {
    
}
</script>

<style scoped>
@import url('../assets/css/style.css');
</style>